let inCart = (cartItems, modelId, productId) => {
	return cartItems.filter(item => item.modelId == modelId && item.productId == productId).length > 0
}

export default inCart


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/inCart.js
 **/